import { useQuery, useMutation } from "@tanstack/react-query";

import { makeApiRequest } from "../../utils";

export const useFetchSpendingGoals = () => {
  return useQuery({
    queryFn: async () => {
      return makeApiRequest({
        endpoint: "/api/spending_goals",
        method: "GET"
      });
    },
    keepPreviousData: false
  });
};

export const useAddSpendingGoal = () => {
  return useMutation({
    mutationFn: async (spendingGoal) => {
      return makeApiRequest({
        endpoint: "/api/spending_goals",
        method: "POST",
        body: spendingGoal,
        json: true
      });
    }
  });
};

export const useUpdateSpendingGoal = () => {
  return useMutation({
    mutationFn: async (spendingGoal) => {
      return makeApiRequest({
        endpoint: `/api/spending_goals/${spendingGoal.id}`,
        method: "PATCH",
        body: spendingGoal,
        json: true
      });
    }
  });
};
